import { get } from "lodash-es";
import { Setting } from "../configuration/pages/settings/models/Setting";
import { Asset } from "../models/Asset";
import { MESApiService, type spParameter } from "../services";

export const getUser = async (UserId: number, UserName: string | null) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "UserId", value: UserId },
		{ name: "UserName", value: UserName },
	];

	const resp = await apiService.callV2("[SEC].[GetUser]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Asset[];
	} else {
		throw new Error(resp.message || "Error fetching assets");
	}
};

export const getAssets = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[MES].[GetAssets]", [], signal);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Asset[];
	} else {
		throw new Error(resp.message || "Error fetching assets");
	}
};

export const getUTLSettings = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[UTL].[GetSettings]", [], signal);
	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Setting[];
	} else {
		throw new Error(resp.message || "Error fetching settings");
	}
};

export const upsertDefaultAreaId = async (
	UserId: number,
	DefaultAreaId: number | null,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "UserId", value: UserId });
	parameters.push({ name: "DefaultAssetId", value: DefaultAreaId });

	const resp = await apiService.callV2(
		"[SEC].[UpsertDefaultAssetId]",
		parameters,
	);
	return resp;
};
